import React, { useCallback, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Loading from "../../components/Loading/Loading";
import TablePublicRoutes from "./TableRoutes/TableRoutes";
import RouteIcon from "@mui/icons-material/Route";
import TerrainIcon from "@mui/icons-material/Terrain";
import { getAllRoutesPublicAPI } from "../../services/routes/routesServices";
import { handleError } from "../../utils/handleError";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import MapPreview from "./MapPreviewRoute";
import { formatDistance } from "../../utils/formatDistance";

const Routes = () => {
  const [loading, setLoading] = useState(false);
  const [previewRouteSelected, setPreviewRouteSelected] = useState({});
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  const getAllRoutesPublic = useCallback(async () => {
    try {
      setLoading(true);
      //Se traen las rutas publicas de la API
      const routes = await getAllRoutesPublicAPI();
      // console.log("Rutas publicas", routes);

      setRows(routes);
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setRows([]);
      setLoading(false);
      toast.error(
        `No se pudieron obtener tus rutas en este momento. \n ${message}`
      );
    }
  }, []);

  useEffect(() => {
    getAllRoutesPublic();
  }, [getAllRoutesPublic, navigate]);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Typography variant="h5">Rutas de la Comunidad</Typography>
      </Box>
      <Loading loading={loading} />
      <TablePublicRoutes
        setLoading={setLoading}
        setPreviewRouteSelected={setPreviewRouteSelected}
        rows={rows ?? []}
      />
      <Box
        sx={{ width: "100%", display: "flex", justifyContent: "center" }}
        id="previewMapProvider"
      >
        <Box
          sx={{
            backgroundColor: "rgba(128, 128, 128, 0.55)",
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 2,
            paddingBottom: 2,
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography className="text-primary fs-2">
            {previewRouteSelected?.nameRoute ?? "Seleccione una ruta"}
          </Typography>
          <Box sx={{ display: "flex", gap: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <RouteIcon className="text-primary " />
                <Typography>Distancia</Typography>
              </Box>
              <Typography>
                {formatDistance(previewRouteSelected?.distance) ?? 0}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <TerrainIcon className="text-primary " />
                <Typography>Terreno</Typography>
              </Box>
              <Typography>{previewRouteSelected?.terrainType ?? 0}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{ height: 500, width: "100%", borderRadius: 5, overflow: "hidden" }}
      >
        <MapPreview
          coordinates={previewRouteSelected?.coordinates ?? []}
          setLoading={setLoading}
        />
      </Box>
    </Box>
  );
};

export default Routes;
